export function buildMediaResolveEndpoint({ persistenceApiUrl, fallbackUrl }) {
  const baseUrl = typeof persistenceApiUrl === "string" ? persistenceApiUrl.trim().replace(/\/+$/, "") : "";
  return baseUrl ? `${baseUrl}/media/resolve` : fallbackUrl;
}
